module.exports = __webpack_public_path__ + "media/images/icons/flags/LU-8880f2f0f6001d1b0786f02afecd9004.svg";